import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OdbsComponent } from 'src/app/odbs/odbs.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { OdbsRoutingModule } from './odbs-routing.module';
import { EinzelabfrageComponent } from './einzelabfrage/einzelabfrage.component';
import { VeraenderungsmitteilungComponent } from './veraenderungsmitteilung/veraenderungsmitteilung.component';
import { KindComponent } from './kind/kind.component';
import { EinzelabfrageErgebnisComponent } from './einzelabfrage-ergebnis/einzelabfrage-ergebnis.component';
import { ContentComponent } from './content/content.component';
import { MitteilungGesendetComponent } from './mitteilung-gesendet/mitteilung-gesendet.component';

@NgModule({
    declarations: [
        OdbsComponent,
        EinzelabfrageComponent,
        VeraenderungsmitteilungComponent,
        KindComponent,
        EinzelabfrageErgebnisComponent,
        ContentComponent,
        MitteilungGesendetComponent,
    ],
    imports: [CommonModule, SharedModule, OdbsRoutingModule],
})
export class OdbsModule {}
